<template>
  <div>
    <v-container fluid>
      <v-row justify="center">
        <v-col cols="12">
          <LandingPage />
          <tenant-switch-dialog ref="refSwitchDialog"></tenant-switch-dialog>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import TenantSwitchDialog from "../components/TenantSwitchDialog.vue";
import LandingPage from "@/components/LandingView.vue";
export default {
  components: { TenantSwitchDialog, LandingPage },
  name: "Download",
  data() {
    return {
      LoaderText: "Loading data...Please wait.",
    };
  },
  async mounted() {
    try {
      const result = await this.$refs.refSwitchDialog.checkTenantName();
      if (!result) {
        const { id } = this.$route.params;
        await this.onFileDownload(id);
      }
    } catch (error) {
      console.log(error, "api error")
    }
  },

  methods: {
    ...mapActions({
      downloadDocumentAPI: "document/downloadDocument",
    }),
    async onFileDownload(documentId) {
      try {
        const params = {
          documentId: documentId,
          filename: documentId,
        };
        const res = await this.downloadDocumentAPI(params);
        var contentType = res.headers["content-type"];
        var blob = new Blob([res.data], { type: contentType });
        var url = window.URL.createObjectURL(blob);
        window.open(url, "_self");
      } catch (error) {
        console.log(error, "api error")
      }
    },
  },
};
</script>

<style>
</style>